import { useUnit } from 'effector-react';
import { $profileFeatureStore } from '@lib/store';
import { FormatUtils } from '@shared/utils';
import type { UserProfileResponse } from '@shared/api/rest/users';
import { SidebarItem, SidebarRow } from '@widgets';
import { Button, Icon } from '@shared/widgets';
import ShieldIcon from '@assets/icons/shield.svg';
import UserIcon from '@assets/icons/user.svg';

interface IUserSidebarItemsProps {
  user: UserProfileResponse;
  setShowDetailsModal: () => void;
  setShowPasswordModal: () => void;
  setShowLockModal: () => void;
  setShowDeleteModal: () => void;
}

export const UserSidebarItems = (props: IUserSidebarItemsProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  if (!props.user) return null;
  return (
    <>
      <SidebarItem title='Profile options' icon={<Icon icon={<UserIcon />} color='inherit' />}>
        <SidebarRow leftRowText='Username' rightRowText={props.user.userName} />
        <SidebarRow leftRowText='First name' rightRowText={props.user.firstName} />
        <SidebarRow leftRowText='Last name' rightRowText={props.user.lastName} />
        {props.user.phoneAreaCode && props.user.phoneNumber && (
          <SidebarRow leftRowText='Phone number' rightRowText={FormatUtils.toPhoneFormat(props.user.phoneAreaCode, props.user.phoneNumber)} />
        )}
        <SidebarRow leftRowText='Position / Role' rightRowText={props.user.position || 'None'} />
        {profileFeatureStore.data?.userManagement.updateUserProfileDetails && (
          <Button color='outlined' className='mb-5' fullWidth onClick={props.setShowDetailsModal}>
            Edit details
          </Button>
        )}
      </SidebarItem>
      <SidebarItem title='Security options' icon={<Icon icon={<ShieldIcon />} color='inherit' />}>
        {profileFeatureStore.data?.userManagement.changeUserPassword && (
          <Button color='outlined' className='mb-5' fullWidth onClick={props.setShowPasswordModal}>
            Change password
          </Button>
        )}
        {profileFeatureStore.data?.userManagement.lockOrUnlockUser && (
          <Button color='outlined' className='mb-5' fullWidth onClick={props.setShowLockModal}>
            {props.user.locked ? 'Unlock user' : 'Lock user'}
          </Button>
        )}
        {profileFeatureStore.data?.userManagement.deleteUser && (
          <Button color='outlined' className='mb-5' fullWidth onClick={props.setShowDeleteModal}>
            Delete user
          </Button>
        )}
      </SidebarItem>
    </>
  );
};
